var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4V1M4.819 5.318L2.697 3.196M3.5 8.5h-3M4.819 11.682l-2.122 2.121M8 13v3M11.183 11.682l2.121 2.121M12.5 8.5h3M11.183 5.318l2.121-2.122M3.5 8.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0v0z",
    stroke: "#228AA8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5a4.501 4.501 0 01-4.177-6.177 4.5 4.5 0 105.853 5.854 4.478 4.478 0 01-1.676.323v0z",
    stroke: "#228AA8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgDarkMode;